import { createReducer, on } from '@ngrx/store';
import { courseActions } from '../actions/course.actions';
import { Course } from '../models';

export interface CourseState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    course: Course | null;
}

export const initialState: CourseState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    course: null,
};

export const courseReducer = createReducer(
    initialState,
    on(courseActions.getCourse, (state): CourseState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(courseActions.getCourseSuccess, (state, { payload }): CourseState => ({
        ...state,
        loading: false,
        loaded: true,
        error: null,
        course: payload,
    })),
    on(courseActions.getCourseError, (state, payload): CourseState => ({
        ...state,
        loading: false,
        loaded: false,
        error: payload.code,
    })),
    on(courseActions.createCourse, (state): CourseState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(courseActions.createCourseSuccess, (state, { payload }): CourseState => ({
        ...state,
        saving: false,
        saved: true,
        course: payload,
    })),
    on(courseActions.createCourseError, (state): CourseState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(courseActions.updateCourse, (state): CourseState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(courseActions.updateCourseSuccess, (state, { payload }): CourseState => ({
        ...state,
        saving: false,
        saved: true,
        course: payload,
    })),
    on(courseActions.updateCourseError, (state): CourseState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(courseActions.deleteCourse, (state): CourseState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(courseActions.deleteCourseSuccess, (state): CourseState => ({
        ...state,
        saving: false,
        saved: true,
        course: null,
    })),
    on(courseActions.deleteCourseError, (state): CourseState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(courseActions.clear, (): CourseState => ({ ...initialState })),
);
